import templateStr from 'text!./templates/ho-edit-coverages.html';

export default [function () {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            model: '=gwPcHoEditCoverages',
            onCovChange: '=',
            onAdditionalCovChange: '=',
            onGeneralChange: '=',
            loading: '=?',
            hideSchedules: '=?'
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/policycommon/ho/directives/HOEditCoverages.js
// module id = 1192
// module chunks = 0